(function(){
  if(window.__gfyLoaded) return; window.__gfyLoaded=true;
  function init(root){
    root.querySelectorAll('[data-gfy-deadline]').forEach(function(d){
      var p=d.dataset.gfyDeadline.split('-');if(p.length!==3)return;
      var end=new Date(+p[0],+p[1]-1,+p[2],23,59,59);
      var days=Math.max(0,Math.ceil((end-new Date())/86400000));
      var n=d.querySelector('[data-gfy-days]'),u=d.querySelector('[data-gfy-unit]');
      if(n)n.textContent=days;if(u)u.textContent=days===1?'day left':'days left';
    });

    function ymd(v,end){var p=(v||'').split('-');if(p.length!==3)return null;return end?new Date(+p[0],+p[1]-1,+p[2],23,59,59):new Date(+p[0],+p[1]-1,+p[2],0,0,0);}
    root.querySelectorAll('[data-gfy-promo]').forEach(function(sec){
      var mode=sec.dataset.gfyPromo;
      if(mode==='auto'){
        var now=new Date(),bs=ymd(sec.dataset.bfcmStart),be=ymd(sec.dataset.bfcmEnd,true),le=ymd(sec.dataset.launchEnd,true);
        var bf=bs&&be&&now>=bs&&now<=be, launch=!bf&&!(le&&now>le);
        var pb=sec.querySelector('[data-gfy-panel="bfcm"]'),pl=sec.querySelector('[data-gfy-panel="launch"]');
        if(pb)pb.hidden=!bf;if(pl)pl.hidden=!launch;sec.hidden=!bf&&!launch;
      }
      sec.querySelectorAll('[data-gfy-select-plan]').forEach(function(a){
        if(a.dataset.gfyBound)return;a.dataset.gfyBound='1';
        a.addEventListener('click',function(){
          var n=(a.dataset.gfySelectPlan||'').toLowerCase();if(!n)return;
          document.querySelectorAll('input[name="selling_plan"]').forEach(function(r){
            var l=r.closest('label');if(!r.checked&&l&&l.textContent.toLowerCase().indexOf(n)>-1){r.checked=true;r.dispatchEvent(new Event('change',{bubbles:true}));}
          });
        });
      });
    });
    var cds=root.querySelectorAll('[data-gfy-countdown]');
    if(cds.length){
      var pad=function(n){return(n<10?'0':'')+n;};
      var tick=function(){cds.forEach(function(c){
        var end=ymd(c.dataset.gfyCountdown,true);if(!end)return;
        var s=Math.max(0,Math.floor((end-new Date())/1000)),d=Math.floor(s/86400);s-=d*86400;var h=Math.floor(s/3600);s-=h*3600;var m=Math.floor(s/60);s-=m*60;
        var v={d:d,h:h,m:m,s:s};c.querySelectorAll('[data-cd]').forEach(function(e){e.textContent=pad(v[e.dataset.cd]);});
        var u=c.querySelector('[data-cd-unit="d"]');if(u)u.textContent=d===1?'day':'days';
      });};
      tick();setInterval(tick,1000);
    }
    root.querySelectorAll('[data-gfy-gallery]').forEach(function(g){
      var main=g.querySelector('.gfy-main, img');
      g.querySelectorAll('[data-gfy-thumb]').forEach(function(t){
        t.addEventListener('click',function(){
          main.src=t.dataset.src; if(t.dataset.srcset) main.srcset=t.dataset.srcset; main.alt=t.dataset.alt||'';
          g.querySelectorAll('[data-gfy-thumb]').forEach(function(o){o.setAttribute('aria-current',o===t?'true':'false');});
        });
      });
    });
    root.querySelectorAll('[data-gfy-features]').forEach(function(s){
      var imgs=s.querySelectorAll('.gfy-feature-img');
      s.querySelectorAll('[data-gfy-feature]').forEach(function(b,i){
        b.addEventListener('click',function(){
          s.querySelectorAll('[data-gfy-feature]').forEach(function(o,j){o.setAttribute('aria-pressed',j===i?'true':'false');});
          imgs.forEach(function(im,j){im.classList.toggle('is-active',j===i);});
        });
      });
    });
    root.querySelectorAll('.gfy-buyform').forEach(function(f){
      var cta=f.querySelector('[data-gfy-cta]'), bar=document.querySelector('[data-gfy-bar-price]');
      function sync(){
        var c=f.querySelector('input[name="selling_plan"]:checked'); if(!c) return;
        if(cta && c.dataset.cta) cta.textContent=c.dataset.cta;
        if(bar && c.dataset.price) bar.textContent=c.dataset.price;
      }
      f.addEventListener('change',sync); sync();
    });
    root.querySelectorAll('form[data-gfy-form]').forEach(function(f){
      if(f.dataset.gfyBound) return; f.dataset.gfyBound='1';
      var err=f.querySelector('[data-gfy-error]');
      function show(m){ if(!err) return alert(m); err.textContent=m; err.hidden=false; }
      f.addEventListener('submit',function(e){
        if(e.defaultPrevented) return;
        e.preventDefault();
        if(err) err.hidden=true;
        var fd=new FormData(f), btn=e.submitter||f.querySelector('[type="submit"]');
        if(f.dataset.requiresPlan==='true' && !fd.get('selling_plan')){ show('Please choose a plan first.'); return; }
        if(btn){ btn.disabled=true; btn.setAttribute('aria-busy','true'); }
        var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
        fetch(root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:fd})
          .then(function(r){ return r.json().then(function(d){ return {ok:r.ok,d:d}; }); })
          .then(function(res){
            if(!res.ok){ var m=res.d.description||res.d.message||'Could not add to cart.'; if(/cannot find variant/i.test(m)) m='This product isn\'t available to buy yet. Make sure it is Active and published to the Online Store.'; throw new Error(m); }
            window.location.href=f.dataset.cartUrl||(root+'cart');
          })
          .catch(function(x){ show(x.message); if(btn){ btn.disabled=false; btn.removeAttribute('aria-busy'); } });
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();